import { render, staticRenderFns } from "./batchDownRecord.vue?vue&type=template&id=15a0d3f5&scoped=true"
import script from "./batchDownRecord.vue?vue&type=script&lang=js"
export * from "./batchDownRecord.vue?vue&type=script&lang=js"
import style0 from "./batchDownRecord.vue?vue&type=style&index=0&id=15a0d3f5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a0d3f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15a0d3f5')) {
      api.createRecord('15a0d3f5', component.options)
    } else {
      api.reload('15a0d3f5', component.options)
    }
    module.hot.accept("./batchDownRecord.vue?vue&type=template&id=15a0d3f5&scoped=true", function () {
      api.rerender('15a0d3f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/homeManage/correctionRecord/batchDownRecord.vue"
export default component.exports